module.exports = __webpack_public_path__ + "img/soldOut-NoLicense.9458dfee.png";